import { BlogPostRepository } from "@/domain/repositories";
import { ApiQuery } from "@/domain/clients";
import { BlogPost, BlogPostListMeta } from "@/domain/entities";
import { BlogPostDataSource } from "../datasources/blog";

export class BlogPostRepoImpl implements BlogPostRepository {
  constructor(private readonly dataSource: BlogPostDataSource) {}

  async getPosts(
    query?: ApiQuery,
  ): Promise<{ data: BlogPost[]; meta?: BlogPostListMeta }> {
    return this.dataSource.getPosts(query);
  }
}
